import { render, staticRenderFns } from "./selectLanguage.vue?vue&type=template&id=0e5ef5c1"
import script from "./selectLanguage.vue?vue&type=script&lang=js"
export * from "./selectLanguage.vue?vue&type=script&lang=js"
import style0 from "./selectLanguage.vue?vue&type=style&index=0&id=0e5ef5c1&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e5ef5c1')) {
      api.createRecord('0e5ef5c1', component.options)
    } else {
      api.reload('0e5ef5c1', component.options)
    }
    module.hot.accept("./selectLanguage.vue?vue&type=template&id=0e5ef5c1", function () {
      api.rerender('0e5ef5c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/pop-up/selectLanguage.vue"
export default component.exports